export const DateFormats = [
  "YYYY-MM-DD",
  "YYYY-MM-DDTHH:mm:ssZ",
  "DD/MM/YYYY",
  "D/M/YYYY",
  "DD/M/YYYY",
  "D/MM/YYYY",
  "DD.MM.YYYY",
  "D.M.YYYY",
  "DD.M.YYYY",
  "D.MM.YYYY",
  "DD-MM-YYYY"
];

import dayjs from "dayjs";
export const FipaDatePlugin = (option, dayjsClass, dayjsFactory) => {
  function getFormat(locale) {
    switch (locale) {
      case "fi":
      case "nb":
      case "et":
      case "uk":
        return "DD.MM.YYYY";
      case "nl":
        return "DD-MM-YYYY";
      case "en":
      case "fr":
        return "DD/MM/YYYY";
      default:
        return "YYYY-MM-DD";
    }
  }

  function getDivider(locale) {
    switch (locale) {
      case "fi":
      case "et":
      case "nb":
      case "uk":
        return ".";
      case "nl":
        return "-";
      default:
        return "/";
    }
  }

  dayjsFactory.date = (stringDate, type) => {
    if (!stringDate) return null;
    let d = dayjs(stringDate, DateFormats);

    if (d.format("YYYY-MM-DD") == "2199-01-01") {
      return " ... ";
    }

    const format = getFormat(d.locale());

    switch (type) {
      case "formal":
        return d.format("D MMMM YYYY");
      case "formalNoYear":
        return d.format("D MMMM");
      case "fullTime":
        d = dayjs(stringDate);
        return d.format(`${format} HH:mm:ss`);
      default:
        return d.format(format);
    }
  };

  dayjsFactory.nicerDate = (start, end) => {
    if (!start) return null;
    const startDate = dayjs(start);
    const endDate = dayjs(end);

    if (!end || startDate.isSame(endDate)) {
      return dayjsFactory.date(start);
    }

    if (dayjs.locale().includes("sv")) {
      return `${dayjsFactory.date(start)} - ${dayjsFactory.date(end)}`;
    }

    const divider = getDivider(startDate.locale());
    const [startYear, startMonth, startDay] = start.split("-");
    const [endYear, endMonth, endDay] = end.split("-");

    // Date is given in ISO YYYY-MM-DD
    // Check if years are the same
    if (startYear == endYear) {
      // Then check if months are same
      if (startMonth == endMonth) {
        return `${startDay}${
          !["/", "-"].includes(divider) ? divider : ""
        } - ${endDay}${divider}${endMonth}${divider}${endYear}`;
      }
      // Else means different months
      return `${startDay}${divider}${startMonth} - ${endDay}${divider}${endMonth}${divider}${endYear}`;
    }
    // Othwerwise just show in full
    return `${dayjsFactory.date(startDate)} - ${dayjsFactory.date(endDate)}`;
  };
};
